import Link from './src/link.mjs';
export { linkEmits, linkProps } from './src/link2.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElLink = withInstall(Link);

export { ElLink, ElLink as default };
//# sourceMappingURL=index.mjs.map
